import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './NotificationBox.module.css';

const NotificationBox = props => {
  const { rootClassName, className, message } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <p className={css.notificationText}>{message}</p>
    </div>
  );
};

NotificationBox.defaultProps = {
  rootClassName: null,
  className: null,
  message: null,
};

NotificationBox.propTypes = {
  rootClassName: string,
  className: string,
  message: string,
};

export default NotificationBox;
